import styled from "styled-components";

/**
 * Wrapper for editable blocks
 */
export const EditableBlock = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 2rem 0;
  p {
    margin-bottom: 0;
  }
  button {
    font-weight: bold;
    font-size: 1.4rem;
  }
  .block {
    width: 100%;
    position: relative;
  }
  .iconWrapper {
    position: absolute;
    top: 0;
    right: 0;
  }
  span {
    font-size: 1.4rem;
    color: ${props => props.theme.lightGreen};
    cursor: pointer;
    padding-left: 0.2rem;
  }
`;
